<template>
  <div class="onboarding-datatable">
    <material-card
      :title="title"
      :text="`Onboarded Accounts`"
      color="orange">
      <v-layout
        row
        wrap
        align-center>
        <v-flex md4>
          <v-text-field
            v-model="search"
            label="Search"
            solo
            outlined
            append-icon="search"
          />
        </v-flex>
        <v-flex class="onboarding-status-filter">
          <!-- <v-checkbox
            v-model="onboardingStatusFilter"
            value="All"
            color="orange"
            label="All"
            hide-details
            class="mt-0 ml-1 onboarding-status-filter-checkbox"
          ></v-checkbox> -->
          <v-checkbox
            v-model="onboardingStatusFilter"
            value="New"
            color="orange"
            label="New"
            hide-details
            class="mt-0 ml-1 onboarding-status-filter-checkbox"
          />
          <v-checkbox
            v-model="onboardingStatusFilter"
            value="In Progress"
            color="orange"
            label="In Progress"
            hide-details
            class="mt-0 ml-1 onboarding-status-filter-checkbox"
          />
           <v-checkbox
            v-model="onboardingStatusFilter"
            value="Training Accounts"
            color="orange"
            label="Training Accounts"
            hide-details
            class="mt-0 ml-1 onboarding-status-filter-checkbox"
          />
          <Can
            I="manage"
            a="reports"
          >
          <HelperCsvDownload
            :data="filteredAccounts"
            :getData="getFilteredAccounts"
            :title="'Onboarding-Report'"
            class="mt-0 ml-1 onboarding-status-filter-checkbox"/>
          </Can> 
        </v-flex>
      </v-layout>
      <v-progress-linear
        v-slot:progress
        v-if="loadingRequest"
        color="orange"
        indeterminate/>
      <v-data-table
        ref="accountList"
        :headers="accountHeaders"
        :items="filteredAccounts"
        :search="search"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPageItems"
        class="accounts-table"
        loading
        loading-text="Loading... Please wait"
        fixed-header
        item-key="Acct_ID"

      >
        <template
          slot="headerCell"
          slot-scope="{ header }">
          <span
            class="subheading font-weight-light text-success text-md-left text--darken-3"
            v-text="header.text"
          />
        </template>
        <template v-slot:items="props">
          <tr :active="props.selected" @click="onRowClick">
            <!-- <td>
              <v-checkbox
                v-model="props.selected"
                color="orange"
                hide-details
              ></v-checkbox>
            </td> -->
            
            <td>
              <a v-if="$can('manage', 'onboarding')" href="#" @click="onEditAccount(props.item)">{{ props.item.Onboarding_Id }}</a>
              <span v-else>{{ props.item.Onboarding_Id }}</span> 
              <!-- <span v-if="type==='view'">{{ props.item.Onboarding_Id }}</span>
              <a
                v-else
                href="#"
                @click="onEditAccount(props.item)">{{ props.item.Onboarding_Id }}</a> -->
              
            </td>

            <td title="Onboarding Status"><helperOnboardingStatusChip :status="props.item.Onboarding_Status" /></td>
            <td title="Opportunity ID">{{ props.item.OppReg_Id }}</td>
            <!-- <td title="ACE Opportunity Number">{{ props.item.Opportunity_Number }}</td> -->
            <td title="Workload Status">{{ props.item.Workload_Status }}</td>
            <td title="Requestor">{{ props.item.Requestor_FullName }}</td>
            <td title="Date Requested">{{ props.item.Date_Requested }}</td>
            <td title="AWS Request Type">{{ props.item.AWS_Req_Type }}</td>
            <td title="Type of Request">{{ props.item.Request_Type }}</td>
            <!-- <td>{{ props.item.Engr_Assigned_To }}</td> -->
            <td title="Engineer Assigned">{{ props.item.Engineer_Name }}</td>
            <td title="Customer Name">{{ props.item.Customer_Name }}</td>
            <td title="Calculated Master Payer">{{ props.item.Calculated_Master_Payer }}</td>
            <td title="Calculated Account Name">{{ props.item.Acct_name }}</td>
            <td title="WBS">{{ props.item.WBS_code }}</td>
            <td title="IWO">{{ props.item.IWO_Code }}</td>
            <td title="AWS Credits">{{ props.item.AWS_credits }}</td>
            <td title="Account Owners">
              <span class="cropped-string-users">
                {{ getCroppedString(getEmails('Account_Owners', props.item.Account_Owners)) }}
              </span>
              <span class="full-string-users none">
                {{ getEmails('Account_Owners', props.item.Account_Owners) }}
              </span>
              <v-icon
                v-if="getEmails('Account_Owners', props.item.Account_Owners).length > 30"
                class="expand-string"
                @click="onExpandString"
                large>expand_more</v-icon>
            </td>
            <td title="IAM Users">
              <span class="cropped-string-users">
                {{ getCroppedString(getEmails('IAM_Users', props.item.IAM_Users)) }}
              </span>
              <span class="full-string-users none">
                {{ getEmails('IAM_Users', props.item.IAM_Users) }}
              </span>
              <v-icon
                v-if="getEmails('IAM_Users', props.item.IAM_Users).length > 30"
                class="expand-string"
                @click="onExpandString"
                large>expand_more</v-icon>
            </td>
            <td title="Notification">
              <span class="cropped-string-users">
                {{ getCroppedString(getEmails('Notification_List', props.item.Notification_List)) }}
              </span>
              <span class="full-string-users none">
                {{ getEmails('Notification_List', props.item.Notification_List) }}
              </span>
              <v-icon
                v-if="getEmails('Notification_List', props.item.Notification_List).length > 30"
                class="expand-string"
                @click="onExpandString"
                large>expand_more</v-icon>
            </td>
            <!-- <td>{{ getEmails('CLoudCheckr_users',props.item.CLoudCheckr_users) }}</td> -->
            <td title="Financial Owners">{{ getEmails('Financial_Owner',props.item.Financial_Owner)}}</td>
            <td title="Restricted">{{ props.item.Acct_Restricted }}</td>
            <td title="Region">{{ props.item.Specific_Region }}</td>
            <td title="Location">{{ props.item.Specific_Location }}</td>
            <td title="Account Purpose">{{ getPrimaryPurpose(props.item.Account_Purpose) }}</td>
            <td title="AwS Support Type">{{ props.item.AWS_Support_Type }}</td>
            <td title="Managed Service Type">{{ props.item.Managed_Svc }}</td>
            <td title="SaaS">{{ props.item.SaaS }}</td>
            <td title="Business Use">{{ props.item.Business_Use }}</td>
            <td title="Business Use">{{ props.item.GovCloud_Resource_Account }}</td>
          </tr>
        </template>
      </v-data-table>
    </material-card>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: ['type', 'title'],
  data () {
    return {
      search: '',
      selected: [],
      onboardingStatusFilter: [],
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 15,
        totalItems: 0
      },
      rowsPerPageItems: [5, 10, 15, {"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}]
    }
  },
  computed: {
    ...mapState('admin/accountOnboarding', ['onboardingAccounts', 'accountHeaders', 'viewRequests', 'loadingRequest']),
    filteredAccounts () {
      if (this.onboardingStatusFilter.length) {
        let filteredData = [];
        if (this.onboardingStatusFilter.includes('New')) {
          let newData = this.onboardingAccounts.filter(account => {
            let newStatuses = ['New']
            return newStatuses.includes(account.Onboarding_Status)
          })
          filteredData = [...filteredData, ...newData]
        }
        if (this.onboardingStatusFilter.includes('In Progress')) {
          let inProgressData = this.onboardingAccounts.filter(account => {
            let inProgressStatuses = ['Request Validation in Progress', 'Account Configuration in Progress', 'ORR in Progress']
            return inProgressStatuses.includes(account.Onboarding_Status)
          })
          filteredData = [...filteredData, ...inProgressData]
        }
        if (this.onboardingStatusFilter.includes('Training Accounts')) {
          let trainingData = this.onboardingAccounts.filter(account => {
            return account.Is_Training_Account === 'Yes'
          })
          filteredData = [...filteredData, ...trainingData]
        }
        return filteredData;
      } else {
        return this.onboardingAccounts
      }
    }
  },
  mounted () {
    this.$store.dispatch('admin/accountOnboarding/getAllOnboardingRequests')
  },
  beforeDestroy () {
    this.$store.commit('admin/accountOnboarding/clearViewRequestData')
  },
  methods: {
    getFilteredAccounts () {
      this.pagination.rowsPerPage = -1
      let data = this.$refs.accountList.filteredItems
      this.pagination.rowsPerPage = 10
      return data
    },
    getEmails (type, data) {
      try {
        switch (type) {
          case 'Account_Owners':
            let owners = JSON.parse(data)
            return owners.map(owner => owner.email).join(', ')
          case 'IAM_Users':
          case 'Notification_List':
          case 'CLoudCheckr_users':
          case 'Financial_Owner':
            let users = JSON.parse(data)
            return users.join(', ')
          default:
            break
        }
      } catch (e) {
        return data
      }
    },
    onExpandString (e) {
      if (e.target.textContent === 'expand_more') {
        e.target.textContent = 'expand_less'
        e.target.previousSibling.classList.remove('none')
        e.target.previousSibling.previousSibling.classList.add('none')
      } else {
        e.target.textContent = 'expand_more'
        e.target.previousSibling.classList.add('none')
        e.target.previousSibling.previousSibling.classList.remove('none') 
      }
    },
    getCroppedString (emails) {
      return emails.length > 30 ? emails.substring(0, 30) + '...' : emails
    },
    getPrimaryPurpose (purposes) {
      try {
        return JSON.parse(purposes).all
      } catch (error) {
        return purposes
      }
    },
    onEditAccount (record) {
      console.log('emit update')
      this.$emit('update', record)
    },
    onRowClick (e) {
      let currentHoveredItem = document.querySelector(".current-item")
      if (currentHoveredItem) {
        currentHoveredItem.classList.remove('current-item')
      }
      e.target.closest('tr').classList.add('current-item')
    }
  }
}
</script>
<style lang="scss" scoped>
  .cropped-string-users.none,
  .full-string-users.none{
    display: none;
  }
  .onboarding-status-filter {
    text-align: right;
  }
  .expand-string {
    font-size: 26px !important;
    line-height: 15px;
    cursor: pointer;
  }
  // tr th:first-child {
  //   position: sticky;
  //   left: 0px;
  //   line-height: 60px;
  //   z-index: 3;
  //   background: #fff;
  // }
  // tr td:first-child {
  //   position: sticky;
  //   left: 0px;
  //   line-height: 60px;
  //   z-index: 3;
  //   background: #fff;
  // }
  .onboarding-status-filter-checkbox {
    display: inline-block;
  }
</style>